import Link from '@mui/material/Link';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { fNumber } from 'src/utils/format-number';

import { IPackagingItemUsageListItem } from 'src/types/packaging-item-usage';

type Props = {
  row: IPackagingItemUsageListItem;
};

export default function PackagingItemUsageTableRow({ row }: Props) {
  const { packagingItem, dispatched, returned, damaged, usage } = row;

  return (
    <TableRow hover>
      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
        <Link
          component={RouterLink}
          href={paths.dashboard.packagingItem.view(packagingItem._id)}
          color="inherit"
          underline="hover"
        >
          {packagingItem.itemName}
        </Link>
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
        {fNumber(dispatched)}
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
        {fNumber(returned)}
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
        {fNumber(damaged)}
      </TableCell>

      <TableCell
        sx={{
          whiteSpace: 'nowrap',
          textAlign: 'right',
          fontWeight: 600,
          color: usage < 0 ? 'error.main' : 'text.primary',
        }}
      >
        {fNumber(usage)}
      </TableCell>
    </TableRow>
  );
}
